import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { StoplossPesquisaComponent } from './stoploss-pesquisa/stoploss-pesquisa.component';
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';

const routes: Routes = [
    {
        path: 'limite-honra/pesquisa',
        component: StoplossPesquisaComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        resolve: {
            agentes: AgenteFinanceiroResolver
        },
        data: { canReuse: false }
    }
];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class StoplossRoutingModule { }
  